module.exports = __webpack_public_path__ + "img/germany-ill-defined-causes-female.817aa367.png";